module.exports = __webpack_public_path__ + "img/0Q3A6078_L_Wood.b5355b4b.jpg";